import React, { useState } from "react";
import { getApi } from '../../api/endpoints';
import ListingPageComponent from '../../components/ListingPageComponent';
import uiManager from '../../../config/ui.js';
import PAGES from '../../data/PagesConstants';
import FiltersPartial from './FiltersPartial.js';

const Index = () => {
    const [filtersModel, setFiltersModel] = useState({});
    const defaultHeaderConfig = { disableSort: true };

    const headers = [
        {
            ...defaultHeaderConfig,
            label: 'ID',
            attr: 'id',
            disableSort: false
        },
        {
            ...defaultHeaderConfig,
            label: 'Customer ID',
            attr: 'customer_id',
        },
        {
            ...defaultHeaderConfig,
            label: 'Challan Amount',
            attr: 'amount',
            disableSort: false
        },
        {
            ...defaultHeaderConfig,
            label: 'Created Date and Time',
            attr: 'created_at',
            disableSort: false
        },
        {
            ...defaultHeaderConfig,
            label: 'Status',
            attr: 'status',
        },
        {
            ...defaultHeaderConfig,
            label: 'Challan Reason',
            attr: 'reason',
        },
    ]

    return <>
        <ListingPageComponent
            key={PAGES.ChallansListingPage.name}
            uiPage={uiManager.getUiPage(PAGES.ChallansListingPage.name)}
            breadcrumbs={[{ label: 'Home', url: '/dashboard' }, { label: 'Challans' }]}
            listingMutation={getApi('challans')}
            className="customer_challans_listing-page"
            contentHeading="Challans - Results"
            headers={headers}
            recordsKey="challans"
            filtersModel={filtersModel}
            filters={
                <FiltersPartial
                    filtersModel={filtersModel}
                    setFiltersModel={setFiltersModel}
                />
            }
            searchBy={['Customer ID']}
        />
    </>
};

export default Index;
